import React from "react";
import ContactForm from "../../Component/Contact/ContactForm"
import Footer from "../../Component/Footer"
const ContactHomePage = () => {
          const d = new Date();
          let year = d.getFullYear();
  return (
    <center>
      <h3 className=" font-bol text-[32px] dark:text-[#FFF] "> Form</h3>
      <div className="horizontal"></div>
      <div>
      <div className="  mt-4  w-full md:p-0 lg:p-2 xl:p-2">
        <div className="flex flex-col  md:justify-center  lg:flex-row  ">
          <div
            className="w-[100%] border-[6px] border-[#17A6DB] dark:border-[#30dada] rounded-[64px] md:w-[100%] lg:ml-[64px] lg:w-[50%]"
           
          >
            <ContactForm />
          </div>

        
        </div>
      </div>
      <p className="text-[#17A6DB] mt-4 dark:text-[#30dada] flex justify-center pb-4 md:pb-0">
          Developed  and Design @{year} by Deepesh Kumar. 
          </p>
          <Footer />
      </div>
    </center>
  );
};

export default ContactHomePage;
